import { t as translate } from "./preferences";

function codeMessage(code: string): string | undefined {
  const messages: Record<string, string> = {
    debt_due_days_required: translate("Qarz muddati 1 dan 3650 kungacha bo‘lishi kerak."),
    client_id_required: translate("Mijozni tanlang."),
    new_client_required: translate("Yangi mijoz ismi va telefonini kiriting."),
    debt_requires_client: translate("Qarzli sotuv uchun mijozni tanlang yoki yarating."),
    duplicate_payment_method: translate("Har bir to‘lov usulini bir marta tanlang."),
    tolangan_summa_required: translate("To‘langan summani kiriting."),
    tolangan_summa_out_of_range: translate("To‘langan summa 0 va jami summa orasida bo‘lishi kerak."),
    tolov_usuli_without_payment: translate("To‘lov bo‘lmasa, to‘lov usuli ko‘rsatilmaydi."),
  };
  return messages[code];
}

/** Decode only the affected warehouse requests; never expose submitted values. */
export function warehouseValidationMessage(code: string, message: string | undefined, detail: unknown): string | undefined {
  const normalized = message?.replace(/[‘’ʻʼ]/g, "'");
  if (message && normalized !== "Noto'g'ri ma'lumot" && normalized !== "Unprocessable Entity") return translate(message);
  const known = codeMessage(code);
  if (known) return known;
  if (typeof detail === "string") return translate(detail);
  if (Array.isArray(detail) && detail.length) {
    return detail.map(issue => {
      if (!issue || typeof issue !== "object") return "";
      const location: unknown[] = Array.isArray(issue.loc) ? issue.loc : [];
      const field = String(location.at(-1) ?? "");
      if (field === "debt_due_days") return codeMessage("debt_due_days_required")!;
      const reasonCode = typeof issue.msg === "string" ? issue.msg.replace(/^Value error, /, "") : "";
      const specific = codeMessage(reasonCode);
      if (specific) return specific;
      const labels: Record<string, string> = {
        phone: translate("Telefon"), full_name: translate("Mijoz ismi"), client_id: translate("Mijoz"),
        name: translate("Yetkazib beruvchi"), supplier_id: translate("Yetkazib beruvchi"),
        miqdor: translate("Miqdor"), quantity: translate("Miqdor"), sotuv_narx: translate("Sotuv narxi"),
        tannarx: translate("Tannarx"), summa: translate("Summa"), tolangan_summa: translate("To‘langan summa"),
        tolov_usuli: translate("To‘lov usuli"), lines: translate("Tovarlar"), payments: translate("To‘lov usuli"),
      };
      const label = labels[field] ?? field;
      const context = issue.ctx ?? {};
      let reason = typeof issue.msg === "string" ? issue.msg : translate("Qiymatni tekshiring.");
      if (issue.type === "missing") reason = translate("Qiymat kiritilishi shart.");
      else if (issue.type === "greater_than") reason = translate(`Qiymat ${context.gt} dan katta bo‘lishi shart.`, `Значение должно быть больше ${context.gt}.`);
      else if (issue.type === "greater_than_equal") reason = translate(`Qiymat ${context.ge} dan kam bo‘lmasligi kerak.`, `Значение должно быть не меньше ${context.ge}.`);
      else if (issue.type === "less_than_equal") reason = translate(`Qiymat ${context.le} dan oshmasligi kerak.`, `Значение должно быть не больше ${context.le}.`);
      else if (issue.type === "string_too_short") reason = translate(`Qiymat kamida ${context.min_length} ta belgidan iborat bo‘lishi kerak.`, `Значение должно содержать не менее ${context.min_length} символов.`);
      else if (issue.type === "string_too_long") reason = translate(`Qiymat ko‘pi bilan ${context.max_length} ta belgidan iborat bo‘lishi kerak.`, `Значение должно содержать не более ${context.max_length} символов.`);
      else if (["int_parsing", "int_type", "int_from_float"].includes(issue.type)) reason = translate("Butun son kiriting.");
      else if (["decimal_parsing", "decimal_type"].includes(issue.type)) reason = translate("Son kiriting.");
      const line = location.indexOf("lines");
      const prefix = line >= 0 && typeof location[line + 1] === "number"
        ? translate(`${Number(location[line + 1]) + 1}-tovar`, `Товар ${Number(location[line + 1]) + 1}`) + ": " : "";
      return prefix + (label ? label + ": " : "") + reason;
    }).filter(Boolean).join("\n") || undefined;
  }
  return message || code === "http_422" || code === "validation_error"
    ? translate("So‘rov rad etildi. Xato kodi:") + " " + code : undefined;
}
